<app-toast></app-toast>

@if (showHeader) {
  <app-header
    [showAdminButton]="isAdminLoggedIn"
    (adminToggle)="isAdminLoggedIn ? toggleAdminDashboard() : toggleAdminPanel()">
  </app-header>
}

<!-- Admin login -->
@if (isAdminPanelOpen && !isAdminDashboardVisible) {
  <app-login
    (closed)="isAdminPanelOpen = false"
    (loginSuccess)="handleAdminLoginSuccess()">
  </app-login>
}


<router-outlet></router-outlet>

<app-footer></app-footer>